import React from 'react';
import { Routes, Route } from "react-router-dom";
import { AuthContextProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';

import AuthRoute from './components/routes/auth-route';
import Login from './pages/auth/login';

import ProtectedRoute from './components/routes/protected-route';
import AdminRoute from './components/routes/admin-route';

import Admin from './pages/admin';
import Dashboard from './pages/admin/dashboard';
import Businesses from './pages/admin/businesses';
import BusinessDetails from './pages/admin/businesses/details';

function App() {

  return (
    <div className='App'>
      <ToastContainer theme='colored' />
      <AuthContextProvider>
        <Routes>
          <Route path='/' element={<AuthRoute><Login /></AuthRoute>} />
          <Route path='/admin' element={<ProtectedRoute> <Admin /> </ProtectedRoute>}>
            <Route path='/admin/dashboard' element={<Dashboard />} />
            <Route path='/admin/businesses' element={<AdminRoute />}>
              <Route path='/admin/businesses' element={<Businesses />} />
              <Route path='/admin/businesses/details/:id' element={<BusinessDetails />} />
            </Route>
          </Route>
          <Route path='*' element={<div><h1>Page Not Found</h1></div>} />
        </Routes>
      </AuthContextProvider>
    </div>
  );
}

export default App;
